import { Stack, Tooltip, Typography } from '@mui/material';
import { CreateMarkupDialogRow } from './CreateMarkupDialogRow';
import { useMarkupTFunction } from '@retail/markup/i18n';
import { MarkupBinding } from '@retail/calculus/types';
import { CheckIcon, InheritedIcon } from '@shared/custom-icons';
import { LevelChip } from '@retail/calculus/components';

interface Props {
  inheritedMarkup: MarkupBinding;
}

export function CurrentActiveMarkup({ inheritedMarkup }: Props) {
  const t = useMarkupTFunction();

  return (
    <Stack gap={2}>
      <Stack direction="row" gap={1} alignItems="flex-start">
        <Typography fontWeight={600}>{t('markup.activeMarkup')}</Typography>
        <Tooltip
          title={
            <Stack gap={2}>
              <Typography variant="subtitle2">{t('markup.activeMarkupOrigin')}</Typography>
              <Stack flexDirection="row" alignItems="center" gap={2}>
                <Typography variant="body2">{t('markup.level')}:</Typography>
                <LevelChip
                  height={28}
                  active
                  bindingType={inheritedMarkup.bindingInfo.bindingType}
                />
              </Stack>
              <Stack flexDirection="row" gap={1}>
                <Typography variant="body2">{t('markup.levelOrItemName')}:</Typography>
                <Typography variant="subtitle2">
                  {inheritedMarkup.bindingInfo.bindingTargetName}
                </Typography>
              </Stack>
            </Stack>
          }
        >
          <div>
            {!inheritedMarkup.isInherited ? <CheckIcon /> : <InheritedIcon fontSize="small" />}
          </div>
        </Tooltip>
      </Stack>
      <CreateMarkupDialogRow
        name={t('markup.salesCoverage')}
        value={inheritedMarkup.coverageDegree ? `${inheritedMarkup?.coverageDegree}%` : '-'}
      />
      <CreateMarkupDialogRow
        name={t('markup.salesFactor')}
        value={inheritedMarkup.salesFactor.toFixed(5)}
      />
    </Stack>
  );
}
